/**
 * A deadline as a day plus an optional time. A day without a time means 18:00 (end of the working day). One
 * date-and-time box used to fill in the current time when you only picked a day, so "due today" became overdue
 * within minutes.
 */
import { useState } from "react";

const pad = (n: number) => String(n).padStart(2, "0");
const parts = (iso: string | null | undefined) => {
  if (!iso) return { date: "", time: "" };
  const d = new Date(iso);
  const time = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  return { date: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`, time };
};

export function DueInput({ value, onChange, disabled }: { value: string | null | undefined; onChange: (iso: string | null) => void; disabled?: boolean }) {
  const [p, setP] = useState(() => parts(value));
  const commit = (next: { date: string; time: string }) => {
    setP(next);
    const iso = next.date ? new Date(`${next.date}T${next.time || "18:00"}`).toISOString() : null;
    if (iso !== (value ? new Date(value).toISOString() : null)) onChange(iso);
  };
  return (
    <span className="flex gap-2">
      <input className="input min-w-0 flex-1" type="date" disabled={disabled} value={p.date} onChange={(e) => commit({ ...p, date: e.target.value })} aria-label="Due day" />
      <input className="input !w-[7.5rem]" type="time" disabled={disabled || !p.date} value={p.time} onChange={(e) => commit({ ...p, time: e.target.value })} aria-label="Due time (empty: 18:00)" title="Optional — no time means 18:00" />
    </span>
  );
}
